import { render, staticRenderFns } from "./contributor.vue?vue&type=template&id=7f201d14"
import script from "./contributor.vue?vue&type=script&lang=js"
export * from "./contributor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports